import { includes } from "lodash";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import RestrictedAccess from "../../../common/js/components/RestrictedAccess";
import DocumentTypeAdmin from "./DocumentTypeAdmin";
import operations from "./ducks/operations";

const DocumentTypeAdminContainer = (props) => {
    const { role } = props;
    const id = props.match.params["id"];

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/document-type/document/*", title: `Document Admin: ${id}` });
    }, []);

    if (includes(["dataAdmin"], role)) {
        return (
            <div>
                <DocumentTypeAdmin {...props} documentTypeId={id} />
            </div>
        );
    } else {
        return <RestrictedAccess />;
    }
};

const mapStateToProps = (state) => {
    return {
        stateDocumentRequirements: state.stateDocumentRequirementsReducer.stateDocumentRequirements,
        role: state.authReducer.userProfile.role,
        errors: state.stateDocumentRequirementsReducer.errors,
        savedDocuments: state.stateDocumentRequirementsReducer.savedDocuments,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleDeleteDocumentType: (documentTypeKey) => {
            return dispatch(operations.deleteDocumentType(documentTypeKey));
        },
        handleInputChange: (field, value) => {
            dispatch(operations.handleInputChange(field, value));
        },
        handleSaveAll: (documentTypeKey, updatedDocumentType) => {
            return dispatch(operations.updateDocumentType(documentTypeKey, updatedDocumentType));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentTypeAdminContainer);
